'use client';

import * as React from 'react';

import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { Check } from 'lucide-react';

import { cn } from '@wwe-portal/ui/lib/lib';
import { cva } from 'class-variance-authority';

const variants = cva(
  'peer shrink-0 border ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
  {
    variants: {
      variant: {
        green:
          'border-green800 data-[state=checked]:bg-green800 data-[state=checked]:border-green800 data-[state=checked]:text-white',
        default:
          'border-primary data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground  data-[state=checked]:border-primary',
        blue: 'border-blue800 data-[state=checked]:bg-blue800 data-[state=checked]:border-blue800 data-[state=checked]:text-white',
      },
      size: {
        medium: 'h-4 w-4 rounded-md ',
        large: 'h-5 w-5 rounded-md ',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'medium',
    },
  }
);

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root> & {
    variant?: 'green' | 'default' | 'blue';
    size?: 'medium' | 'large';
  }
>(({ className, variant, size, ...props }, ref) => (
  <CheckboxPrimitive.Root
    className={cn(variants({ variant, size }), className)}
    {...props}
    ref={ref}
  >
    <CheckboxPrimitive.Indicator
      className={cn('flex items-center justify-center text-current')}
    >
      <Check className="h-4 w-4 font-bold text-white" />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
